import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import { BudgetHoshin } from '../bpg-common/services/data.services';

@Injectable({
  providedIn: 'root'
})
export class HoshinBudgetService {

  constructor(private readonly http: HttpClient,
    private readonly bpgCommonService: BpgCommonService) { }

  URI: string = ConstantValues.financeManagementApiUrl.financeManagementUrl;
  saveBudgetUrl: string = ConstantValues.financeManagementApiUrl.saveBudgetUrl;
  getHoshinsUrl: string = ConstantValues.financeManagementApiUrl.getHoshinsUrl;
  getCloneHoshinsUrl: string = ConstantValues.financeManagementApiUrl.cloneHoshineUrl;
  getBudgetList: string = ConstantValues.financeManagementApiUrl.getBudget;
  deleteBudgetUrl: string = ConstantValues.financeManagementApiUrl.deleteBudget;
  getBaseHoshinMasterForHoshinIdUrl: string = ConstantValues.financeManagementApiUrl.getBaseHoshinMasterForHoshinId;
  getHoshinForSingleUserUrl: string = ConstantValues.financeManagementApiUrl.getHoshinForSingleUser
  getKpiDetailsUrl: string = ConstantValues.financeManagementApiUrl.getKpiDetails;
  getHoshinYearsUrl: string = ConstantValues.financeManagementApiUrl.getHoshinYears;
  saveHoshinReviewUrl: string = ConstantValues.financeManagementApiUrl.saveHoshinReview;
  saveHoshinGoalsUrl: string = ConstantValues.financeManagementApiUrl.saveHoshinGoals;
  saveHoshinInitiativeUrl: string = ConstantValues.financeManagementApiUrl.saveHoshinInitiative;
  saveHoshinKpiUrl: string = ConstantValues.financeManagementApiUrl.saveHoshinKpi;
  deleteHoshinInitativeUrl : string = ConstantValues.financeManagementApiUrl.deleteHoshinInitative;
  deleteHoshinKpiUrl: string = ConstantValues.financeManagementApiUrl.deleteHoshinKpi;
  cloneHoshinsUrl: string = ConstantValues.financeManagementApiUrl.cloneHoshins;
  approveorRejectHoshinUrl : string = ConstantValues.financeManagementApiUrl.approveorRejectHoshin;
  submitHoshinUrl: string = ConstantValues.financeManagementApiUrl.submitHoshin;
  getPastHoshinsUrl: string = ConstantValues.financeManagementApiUrl.getPastHoshins;
  getHoshinChaptersUrl: string = ConstantValues.financeManagementApiUrl.getHoshinChapters;
  /** For service call to save budget and hoshin
  * @class HoshinBudgetService
  * @method saveBudget
  * @param hoshinBudgetDTO
  * @returns Observable
  */
  public saveBudget(hoshinBudgetDTO: BudgetHoshin): Observable<any> {
    return this.http.post(this.URI + this.saveBudgetUrl, hoshinBudgetDTO, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
       throw of(error);
    }))

  }

  /** For service call to get hoshins
  * @class HoshinBudgetService
  * @method getHoshins
  * @param budgetId
  * @returns Observable
  */
  public getHoshins(budgetId: number): Observable<any> {
    return this.http.post(this.URI + this.getHoshinsUrl, budgetId, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get hoshins
* @class HoshinBudgetService
* @method getHoshinForSingleUser
* @param userId 
* @returns Observable
*/
  public getHoshinForSingleUser(hoshinData): Observable<any> {
    return this.http.post(this.URI + this.getHoshinForSingleUserUrl, hoshinData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }


  /** For service call to get hoshins
* @class HoshinBudgetService
* @method getHoshinYears
* @param userId 
* @returns Observable
*/
  public getHoshinYears(userData): Observable<any> {
    return this.http.post(this.URI + this.getHoshinYearsUrl,userData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

    /** For service call to get hoshins
* @class HoshinBudgetService
* @method getHoshinYears
* @param userId 
* @returns Observable
*/
public getPastHoshins(hoshinData): Observable<any> {
  return this.http.post(this.URI + this.getPastHoshinsUrl,hoshinData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  })).pipe(catchError((error: any) => {
    throw of(error);
  }))

}
  /** For service call to get hoshins
* @class HoshinBudgetService
* @method getHoshinForSingleUser
* @param userId 
* @returns Observable
*/

  public getKpiDetails(businessDrivers: string): Observable<any> {
    return this.http.get(this.URI + this.getKpiDetailsUrl + businessDrivers, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to clone hoshins
* @class HoshinBudgetService
* @method cloneHoshins
* @param cloneData 
* @returns Observable
*/

public cloneHoshins(cloneData: any): Observable<any> {
  return this.http.post(this.URI + this.cloneHoshinsUrl , cloneData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  })).pipe(catchError((error: any) => {
    throw of(error);
  }))

}
  /** For service call to save hoshin review
* @class HoshinBudgetService
* @method saveHoshinReview
* @param reviewData 
* @returns Observable
*/

  public saveHoshinReview(reviewData: any): Observable<any> {
    return this.http.post(this.URI + this.saveHoshinReviewUrl, reviewData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
    /** For service call to save hoshin review
* @class HoshinBudgetService
* @method saveHoshinReview
* @param reviewData 
* @returns Observable
*/

public submitHoshin(reviewData: any): Observable<any> {
  return this.http.post(this.URI + this.submitHoshinUrl, reviewData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  })).pipe(catchError((error: any) => {
    throw of(error);
  }))

}
  /** For service call to save hoshin goals
* @class HoshinBudgetService
* @method saveHoshinGoals
* @param goalData 
* @returns Observable
*/

  public saveHoshinGoals(goalData: any): Observable<any> {
    return this.http.post(this.URI + this.saveHoshinGoalsUrl, goalData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to save hoshin goals
* @class HoshinBudgetService
* @method saveHoshinGoals
* @param goalData 
* @returns Observable
*/

  public saveHoshinInitiative(initiativeData: any): Observable<any> {
    return this.http.post(this.URI + this.saveHoshinInitiativeUrl, initiativeData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
     throw of(error);
    }))

  }
  /** For service call to save hoshin kpi
* @class HoshinBudgetService
* @method saveHoshinKpi
* @param goalData 
* @returns Observable
*/

  public saveHoshinKpi(kpiData: any): Observable<any> {
    return this.http.post(this.URI + this.saveHoshinKpiUrl, kpiData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
   /** For service call to save hoshin kpi
* @class HoshinBudgetService
* @method saveHoshinKpi
* @param goalData 
* @returns Observable
*/

public approveorRejectHoshin(approvalData: any): Observable<any> {
  return this.http.post(this.URI + this.approveorRejectHoshinUrl, approvalData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  })).pipe(catchError((error: any) => {
    throw of(error);
  }))

}

    /** For service call to delete hoshin 
* @class HoshinBudgetService
* @method saveHoshinKpi
* @param goalData 
* @returns Observable
*/

public deleteHoshinInitative(userId: any, hoshinId): Observable<any> {
  return this.http.post(`${this.URI}${this.deleteHoshinInitativeUrl}${hoshinId}/${userId}`, {}, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  })).pipe(catchError((error: any) => {
    throw of(error);
  }))

}
    /** For service call to delete hoshin 
* @class HoshinBudgetService
* @method saveHoshinKpi
* @param goalData 
* @returns Observable
*/

public deleteHoshinKpi(hoshinId , kpiId: any,userId: any, ): Observable<any> {
  return this.http.post(`${this.URI}${this.deleteHoshinKpiUrl}${hoshinId}/${kpiId}/${userId}`, {}, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  })).pipe(catchError((error: any) => {
    throw of(error);
  }))

} 

  /** For service call to get hoshins
  * @class HoshinBudgetService
  * @method getCloneHoshins
  * @param budgetId
  * @returns Observable
  */
  public getCloneHoshins(budgetId: number): Observable<any> {
    return this.http.get(`${this.URI}${this.getCloneHoshinsUrl}${budgetId}`, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get budget list
  * @class HoshinBudgetService
  * @method getBudgetListing
  * @param landingDTO
  * @returns Observable
  */

  public getBudgetListing(landingDTO: any): Observable<any> {

    return this.http.post(this.URI + this.getBudgetList, landingDTO, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to delete budget
   * @class HoshinBudgetService
   * @method deleteClick
   * @param landingDTO
   * @returns Observable
   */

  public deleteBudget(id): Observable<any> {
    return this.http.delete(this.URI + this.deleteBudgetUrl + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get hoshin for pop up
   * @class HoshinBudgetService
   * @method getBaseHoshinMasterForHoshinId
   * @param hoshinId
   * @returns Observable
   */

  public getBaseHoshinMasterForHoshinId(hoshinId): Observable<any> {
    return this.http.post(this.URI + this.getBaseHoshinMasterForHoshinIdUrl + hoshinId, {}, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get chapters list in hoshins table
   * @class HoshinBudgetService
   * @method getHoshinChapterListing
   * @param hoshinId
   * @returns landingDTO
   */
  public getHoshinChapterListing(landingDTO: any): Observable<any> {

    return this.http.post(this.URI + this.getHoshinChaptersUrl, landingDTO, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
}
